import {
  CheckCircle as CheckCircleIcon,
  Schedule as ScheduleIcon,
} from "@mui/icons-material";
import {
  Box,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { formatTime } from "@pages/OrderTracker/components/PlanningAutomation/Timer";
import type { ActiveJobOut } from "@providers/hop-ord-server/api";
import { tableStyles } from "./utils";

interface ActiveJobsTableProps {
  activeJobs: ActiveJobOut[];
}

const JobStatusIcon = ({ retries }: { retries: number }) => {
  return retries > 1 ? (
    <ScheduleIcon color="warning" />
  ) : (
    <CheckCircleIcon color="success" />
  );
};

export const ActiveJobsTable = ({ activeJobs }: ActiveJobsTableProps) => (
  <TableContainer component={Paper} variant="outlined">
    <Table size="small" sx={tableStyles}>
      <TableHead>
        <TableRow>
          <TableCell>Job ID</TableCell>
          <TableCell>Consumer</TableCell>
          <TableCell>Stream</TableCell>
          <TableCell align="right">Elapsed Time</TableCell>
          <TableCell align="right">Attempt</TableCell>
          <TableCell align="center">Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {activeJobs.length === 0 ? (
          <TableRow>
            <TableCell colSpan={6} align="center">
              <Stack
                sx={{
                  alignItems: "center",
                  gap: 1,
                  py: 2,
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                  }}
                >
                  No active jobs found
                </Typography>
              </Stack>
            </TableCell>
          </TableRow>
        ) : (
          activeJobs.map((job, index) => (
            <TableRow
              key={`${job.jobId || "unknown"}-${index}`}
              sx={{
                backgroundColor: job.retryCount > 1 ? "error.light" : "inherit",
              }}
            >
              <TableCell>{job.jobId}</TableCell>
              <TableCell>{job.consumerName || "Unknown"}</TableCell>
              <TableCell>{job.streamName}</TableCell>
              <TableCell align="right">
                {formatTime(Math.floor(job.elapsedTimeMs / 1000))}
              </TableCell>
              <TableCell align="right">
                <Typography
                  sx={{
                    ...(job.retryCount > 1
                      ? { fontWeight: "bold", color: "error.main" }
                      : {}),
                  }}
                >
                  {job.retryCount}
                </Typography>
              </TableCell>
              <TableCell>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <JobStatusIcon retries={job.retryCount} />
                </Box>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  </TableContainer>
);
